//
// ReportSchemaVersion.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./MediaType";

var ReportSchemaVersion = createModule("transport::ReportSchemaVersion", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::MediaType"], EventDispatcher, [
    ,
    {
        schema: 7,
        mediaType: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ReportSchemaVersion;
